<template>
  <v-container class="pt-0" bg fill-height grid-list-md text-xs-center>
    <v-row v-if="loading" align="start">
      <v-col align="center">
        <v-progress-circular indeterminate color="primary" />
      </v-col>
    </v-row>
    <div v-else class="containerCardsWide">
      <Card
          :is-edit="true"
      >
        <v-tabs
          v-model="currentTab"
          center-active
        >
          <template v-for="(tab, index) in tabs">
            <div
              class="round"
              v-if="index > 0"
              :style="{ opacity: currentTab === tab.key ? 1 : 0.62 }"
            ></div>
            <v-tab
              :value="tab.key"
              variant="plain"
              :class="{ 'filled' : tab.isFilled }"
              :disabled="tab.key > nextAvailableTabIndex"
              @click="(e) => trySelectTab(tab, index, e)"
            >
              {{ $t(tab.content) }}
            </v-tab>
          </template>
        </v-tabs>
      </Card>

      <v-form v-model="valid" ref="form">
        <v-tabs-window v-model="currentTab">
          <v-tabs-window-item
            :value="0"
            transition="false"
            reverse-transition="false"
            eager
          >
            <v-form ref="general">
              <GeneralInfo
                is-edit
                v-model:name="procedure.goodName"
                v-model:type="procedure.type"
                :registry-number="procedure.registryNumber"
                :types="getTypes"
                :procedureId="procedure.id"
                :maxStartPrice="procedure.startMaxPrice"
                :isWithoutStartMaxPrice="procedure.isWithoutStartMaxPrice"
                :isNds="procedure.isNds"
                :canChangeType="access.canChangeType"
                :name-rules="[].concat(validation.required(), validation.text(2000))"
                :type-rules="[].concat(validation.required())"
                :disabled="processing"
                :isClosed="procedure.isClosed"
              />
              <ContactPerson
                v-if="!isHiddenContractPerson"
                :contact="procedure.contactPerson"
                @update:contact="procedure.contactPerson = $event"
              />
              <OpenCloseInfo
                v-if="false"
                v-model:is-closed="procedure.isClosed"
                v-model:allowedContragents="procedure.allowedContragents"
                :applications="applications"
              />
              <CategoriesSelect
                v-if="categoriesAll.total > 0"
                :card-title="$t('Категории поставщиков')"
                :categories="categoriesAll"
                :categories-selected="procedure.categories"
                @update:categories-selected-list="procedure.categories = $event"
              />
            </v-form>
          </v-tabs-window-item>

          <v-tabs-window-item
            :value="1"
            transition="false"
            reverse-transition="false"
            eager
          >
            <v-form ref="subject">
              <SubjectInfo
                is-edit
                class="mb-3"
                v-model:subject="procedure.subject"
                v-model:start-max-price="procedure.startMaxPrice"
                v-model:is-without-start-max-price="procedure.isWithoutStartMaxPrice"
                v-model:is-nds="procedure.isNds"
                v-model:additional-information="procedure.additionalInformation"
                :procedure-type="procedure.type"
                :start-max-price-rules="[].concat(validation.number(0.01, 999_999_999_999.99))"
                :disabled="processing"
                :procedure="procedure"
              />
              <component
                v-if="positionsInfoComponent"
                :is="positionsInfoComponent"
                ref="positions"
                v-model:part-of-volume="procedure.partOfVolume"
                v-model:positions="procedure.positions"
                :canEdit="access.canChangePositions"
                :measures="measures"
                :procedure-type="procedure.type"
                @changed.once="procedure.positionsEdited = true"
              />
              <PositionsInfo
                v-else
                ref="positions"
                v-model:part-of-volume="procedure.partOfVolume"
                v-model:positions="procedure.positions"
                :canEdit="access.canChangePositions"
                :measures="measures"
                :procedure-type="procedure.type"
                @changed.once="procedure.positionsEdited = true"
              />
              <FileInput
                is-edit
                :upload-extensions="allowedUploadExtensions"
                :documents="documents"
                :upload-file="(file) => onUpload(file, ProcedureDocumentType.PROCEDURE.code)"
                :delete-file="(file) => onDocDelete(file, 'documents')"
                :download-file="downloadDocument"
                :download-all-files="() => downloadDocuments(procedure.id, ProcedureDocumentType.PROCEDURE.code)"
                :file-rules="rules.checkFile"
                :on-error="showError"
                :format-file-info="[
                  (file) => filters.formatMinuteTimeNoTZ(file.createdAt),
                  (file) => file.fileSizeFmt.toLowerCase()
                  ]"
              >
                <template v-slot:file-icon="{ document }">
                  <FileIcon :document="document" />
                </template>
              </FileInput>
              <FileInput
                v-if="!subjectInfoStore.isPositionsRequired"
                title="Проект договора"
                is-edit
                :upload-extensions="allowedUploadExtensions"
                :documents="projectDocuments"
                :upload-file="(file) => onUpload(file, ProcedureDocumentType.PROJECT_AGREEMENT.code)"
                :delete-file="(file) => onDocDelete(file, 'projectDocuments')"
                :download-file="downloadDocument"
                :download-all-files="() => downloadDocuments(procedure.id, ProcedureDocumentType.PROJECT_AGREEMENT.code)"
                :file-rules="rules.checkFile"
                :on-error="showError"
                :format-file-info="[
                  (file) => filters.formatMinuteTimeNoTZ(file.createdAt),
                  (file) => file.fileSizeFmt.toLowerCase()
                ]"
              >
                <template v-slot:file-icon="{ document }">
                  <FileIcon :document="document" />
                </template>
              </FileInput>
            </v-form>
          </v-tabs-window-item>

          <v-tabs-window-item
            :value="2"
            transition="false"
            reverse-transition="false"
            eager
          >
            <component
              v-if="customStageComponent"
              ref="customStage"
              :is="customStageComponent"
              :procedure="procedure"
              :errors="errors"
              :access="access"
              :disabled-date="pickersDisabledDate"
              :updateFilledTabs="updateFilledTabs"
            />
            <SupplierRequirements
              ref="requirements"
              v-model:requirements="procedure.requirements"
              @changed.once="procedure.requirementsEdited = true"
              :canEdit="access.canChangeRequirements"
              :types="requirementsTypes"
            />
          </v-tabs-window-item>
        </v-tabs-window>
        <div class="procedureOperations">
          <v-btn
              v-if="currentTab !== 0"
              flat
              color="primary"
              density="comfortable"
              variant="outlined"
              style="margin-right: auto;"
              @click="(e) => trySelectTab(tabs[currentTab - 1], currentTab - 1, e)"
          >{{ $t('Назад') }}</v-btn>
          <v-btn
              flat
              color="primary"
              density="comfortable"
              variant="outlined"
              @click="saveAction"
              :disabled="processing || !checkClosedReq"
              :loading="saving"
          >
            {{ access.canPublish ? $t('Сохранить') : $t('Обновить') }}
          </v-btn>
          <v-btn
              v-if="currentTab !== tabs.length - 1"
              flat
              color="primary"
              density="comfortable"
              variant="elevated"
              class="ml-4"
              @click="(e) => trySelectTab(tabs[currentTab + 1], currentTab + 1, e)"
          >{{ $t('Далее') }}</v-btn>
          <v-btn
              flat
              color="primary"
              density="comfortable"
              variant="elevated"
              class="ml-4"
              @click="publishAction"
              v-if="access.canPublish && currentTab === tabs.length - 1"
              :loading="publishing"
              :disabled="processing || !access.canPublish || !checkClosedReq"
          >{{ $t('Опубликовать') }}</v-btn>
        </div>
      </v-form>
    </div>
    <ConfirmDialog ref="confirm" />
  </v-container>
</template>

<script>
import api from '@/api';
import Config from '@/config';
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";
import { formatDateTimeNoTz, formatMinuteTimeNoTZ } from '@/filters';
import { ProcedureDocumentType } from '@/lib/file';
import { mask } from 'vue-the-mask';
import { toast } from '@/lib/toast';
import ProcedureActions from "../components/ProcedureActions.vue";
import MoneyInput from '@intec/vue-components/form/MoneyInput';
import GeneralInfo from '../components/procedure/GeneralInfo';
import StagesInfo from "../components/procedure/StagesInfo.vue";
import StatusInfo from "../components/procedure/StatusInfo.vue";
import FileInput from "@intec/vue-components/form/FileInput.vue";
import SubjectInfo from "../components/procedure/SubjectInfo.vue";
import validation from "@/components/validation";
import Card from '@intec/vue-components/form/Card.vue';
import ContactPerson from '@/components/procedure/ContactPerson.vue';
import { checkFileValidation } from '@/lib/file';
import SupplierRequirements from "@/components/supplierRequirements/SupplierRequirements.vue";
import PositionsInfo from "@/components/positions/PositionsInfo.vue";
import { useProcedureStepStore } from "@/stores/procedureStepStore";
import { useProcedureStageComponentStore } from "@/stores/procedureStageComponentStore";
import { mapStores } from "pinia";
import OpenCloseInfo from "@/components/procedure/OpenCloseInfo.vue";
import CategoriesSelect from '@/components/categories/CategoriesSelect.vue';
import FileIcon from "@/components/FileIcon.vue";
import { useLibraryStore } from "@/stores/library";
import { useProcedureCreateStore } from "@/stores/procedureCreateStore";
import { useSubjectInfoStore } from "@/stores/subjectInfoStore";
import { usePositionsInfoComponentStore } from "@/stores/component/positionsInfoComponentStore";

export default {
  name: 'ProcedureCreate',
  components: {
    CategoriesSelect,
    OpenCloseInfo,
    SupplierRequirements,
    PositionsInfo,
    ProcedureActions,
    SubjectInfo,
    FileInput,
    StatusInfo,
    StagesInfo,
    ConfirmDialog,
    MoneyInput,
    GeneralInfo,
    ContactPerson,
    Card,
    FileIcon
  },
  data() {
    return {
      id: this.$route.params['id'],
      currentTab: 0,
      lastTab: 0,
      nextAvailableTab: 0,
      tabs: [
        {key: 0, content: 'Базовая информация', isFilled: false, required: true},
        {key: 1, content: 'Предмет договора и спецификация', isFilled: false, required: true},
        {key: 2, content: 'Порядок проведения процедуры', isFilled: false, required: true}
      ],
      loading: false,
      saving: false,
      publishing: false,
      processing: false,
      valid: true,
      errors: {
        applicationDeadline: null,
        summingStart: null,
      },
      pickersDisabledDate: (date) => date < new Date(new Date().setHours(0, 0, 0, 0)),
      procedure: {
        id: null,
        registryNumber: '',
        type: '',
        goodName: '',
        subject: '',
        applicationDeadline: null,
        summingStart: null,
        startMaxPrice: null,
        isWithoutStartMaxPrice: false,
        isNds: null,
        partOfVolume: false,
        additionalInformation: null,
        shippingCondition: '',
        positions: [],
        positionsEdited: false,
        requirementsEdited: false,
        status: {
          name: '',
          code: '',
        },
        orgFullName: '',
        contactPerson: {
          userFullName: null,
          userPhone: null,
          userEmail: null
        },
        isClosed: false,
        allowedContragents: [],
        categories: []
      },
      access: {
        canPublish: false,
        canChangeType: false,
        canChangePositions: false,
        canChangeRequirements: false,
      },
      applications: [],
      customers: [],
      types: [],
      documents: [],
      projectDocuments: [],
      allowedUploadExtensions: (Config.get('config').allowedUploadExtensions || []).join(','),
      isHiddenContractPerson: Config.getConfig('HIDDEN_CONTACT_PERSON'),
      requirementsTypes: [],
      measures: [],
      categoriesAll: [],
      rules: {
        checkFile: [checkFileValidation],
      },
      filters: {
        formatDateTimeNoTz: formatDateTimeNoTz,
        formatMinuteTimeNoTZ: formatMinuteTimeNoTZ,
      },
      ProcedureDocumentType,
      validation
    };
  },
  directives: { mask },
  methods: {
    async updateFilledTabs() {
      await Promise.all(this.tabs.map(async t => {
        t.isFilled = await this.isFilledTab(t.key);
      }));
    },
    async trySelectTab(tab, index, event) {
      await this.updateFilledTabs();

      if (index < this.lastTab) {
        return  this.selectTab(tab);
      }
      const currentValid = await this.isValidTab(this.lastTab);
      if (index <= this.nextAvailableTabIndex && currentValid) {
        return this.selectTab(tab);
      }

      let errorText;
      if (!this.checkClosedReq) {
        errorText = "Необходимо указать участника для доступа к закрытой процедуре";
      } else if (this.procedureCreateStore.isPositionsRequired && (!this.procedure.positions || this.procedure.positions.length === 0) && tab.key === 2) {
        errorText = "Необходимо добавить хотя бы одну позицию ТРУ";
      } else {
        errorText = "Проверьте правильность заполнения формы";
      }

      toast.error(errorText);
      event?.currentTarget?.blur();
      this.currentTab = this.lastTab;
    },
    async selectTab(tab) {
      this.currentTab = tab.key;
      this.lastTab = tab.key;
    },
    async isValidTab(key) {
      switch (key) {
        case 0:
          return (await this.$refs.general.validate()).valid && this.checkClosedReq
        case 1:
          return (await this.$refs.subject.validate()).valid && (await this.$refs.positions?.validate()).valid;
        case 2:
          const reqValid = await this.$refs.requirements.validate();
          const validDate = await this.validateDate();
          return reqValid.valid && validDate;
        default:
          return false;
      }
    },
    async isFilledTab(key) {
      switch (key) {
        case 0:
          return this.procedure.type && this.procedure.goodName && this.checkClosedReq;
        case 1:
          return this.procedure.subject &&
            ((this.procedure.startMaxPrice && this.procedure.isNds !== null || this.procedure.isWithoutStartMaxPrice) ||
            (this.subjectInfoStore.isPositionsRequired && this.procedure.positions.length));
        case 2:
          switch (this.procedure.type) {
            case 'proposalsRequest':
              return this.procedure.summingStart
                  && this.procedure.applicationDeadline
                  && !this.errors.applicationDeadline
                  && !this.errors.summingStart;
            default:
              if (this.$refs.customStage?.isFilled) {
                return await this.$refs.customStage.isFilled();
              }

              return false;
          }
        default:
          return false;
      }
    },
    async publishAction() {
      if (await this.validateAll()) {
        let shouldPublish = await this.$refs.confirm.open(
          'Опубликовать',
          'Вы действительно хотите опубликовать процедуру?',
        );
        if (!shouldPublish) {
          return;
        }
        this.processing = true;
        this.publishing = true;
        try {
          await this.saveDraft();
          await this.publish();
          this.showProcedures();
        } catch (e) {
          toast.error(e.message);
        }
        this.processing = false;
        this.publishing = false;
      }
    },
    async saveAction() {
      this.processing = true;
      this.saving = true;
      try {
        await this.saveDraft();
      } catch (e) {
        toast.error(e.message);
      }
      this.processing = false;
      this.saving = false;
    },
    async saveDraft() {
      if (!this.access.canPublish) {
        let shouldUpdate = await this.$refs.confirm.open(
          'Обновить',
          'Вы действительно хотите обновить процедуру?',
        );
        if (!shouldUpdate) {
          return;
        }
      }
      if (await this.validateAll()) {
        let formData = new FormData();
        this.procedure.categories = this.procedure.categories.map(c => c.id);
        const customProps = this.$refs.customStage?.getValues?.();
        const payload = {
          ...this.procedure,
          ...(customProps || {}),
        };
        formData.append('data', JSON.stringify(payload));
        await api.post('/procedures/saveDraft/' + this.procedure.id, formData);
        await this.loadForm(this.procedure.id);
        if (!this.access.canPublish) {
          toast.info('Процедура обновлена успешно');
          this.showProcedures();
        }
      }
    },
    async publish() {
      return await api.post('/procedures/publish/' + this.procedure.id);
    },
    async fetchRequirementTypes() {
      this.loading = true;
      try {
        this.requirementsTypes = await api.get('/vocab/requirementTypes');
      } catch (e) {
        toast.error(e.message);
      } finally {
        this.loading = false;
      }
    },
    loadSupplierRequirements() {
      if (!this.procedure.requirements) return;
      this.procedure.requirements = this.procedure.requirements.map(item => ({
        ...item,
        isItemEdit: false, // Все загруженные элементы свернуты.
      }));
    },
    async loadForm(procedureId) {
      try {
        this.loading = true;
        let resp = await api.get('/procedures/loadDraft/' + procedureId);
        this.procedure = resp.procedure;
        this.loadSupplierRequirements();
        this.procedure.applicationDeadline = this.procedure.applicationDeadline ? new Date(
          this.procedure.applicationDeadline,
        ) : null;
        this.procedure.summingStart = this.procedure.summingStart ? new Date(
          this.procedure.summingStart,
        ) : null;
        this.procedure.categories = this.procedure.categories;
        this.procedure.positionsEdited = false;
        this.procedure.requirementsEdited = false;
        this.documents = resp.documents;
        this.projectDocuments = resp.projectDocuments;
        this.customers = resp.customers;
        this.applications = resp.applications;
        this.types = resp.types;
        this.access = resp.access;
        this.measures = resp.measures;
        this.categoriesAll = resp.categoriesAll;
        this.loading = false;
      } catch (e) {
        toast.error(e.message);
      }
    },
    async onUpload(file, documentType) {
      let data = new FormData();
      data.append('file', file);
      data.append('procedureId', this.id);
      data.append('documentType', documentType);
      let resp = await api.post('/procedures/uploadDocument', data);
      if (documentType === ProcedureDocumentType.PROCEDURE.code) {
        this.documents = resp.documents;
      } else if (documentType === ProcedureDocumentType.PROJECT_AGREEMENT.code) {
        this.projectDocuments = resp.documents;
      }
    },
    downloadDocument(documentId) {
      window.location.href = '/procedures/downloadDocument/' + documentId;
    },
    async downloadDocuments(procedureId, documentType) {
      window.location.href = `/procedures/downloadDocuments/${procedureId}/${documentType}`;
    },
    async onDocDelete(item, documents) {
      let documentId = item.id;
      await api.delete(`/procedures/document/${documentId}`);
      this[documents] = this[documents].filter((doc) => doc.id !== item.id);
    },
    async validateDate() {// Если есть кастомная валидация — используем только её
      if (this.$refs.customStage?.validate) {
        return await this.$refs.customStage.validate();
      }

      this.clearDateErrors();

      const now = new Date();
      let valid = true;

      // Проверка на обязательность.
      if (this.validateRequired(this.procedure.applicationDeadline, 'applicationDeadline')) {
        valid = false;
      }
      if (this.validateRequired(this.procedure.summingStart, 'summingStart')) {
        valid = false;
      }

      // Проверка на дату в прошлом.
      if (this.procedure.applicationDeadline && this.procedure.applicationDeadline < now) {
        this.errors.applicationDeadline = this.$t('Приём заявок не может быть раньше текущей даты');
        valid = false;
      }

      if (this.procedure.summingStart && this.procedure.summingStart < now) {
        this.errors.summingStart = this.$t('Подведение итогов не может быть раньше текущей даты');
        valid = false;
      }

      // Логические зависимости.
      if (this.procedure.applicationDeadline
          && this.procedure.summingStart
          && this.procedure.applicationDeadline > this.procedure.summingStart
      ) {
        this.errors.summingStart = this.$t('Подведение итогов не может быть раньше даты приема заявок');
        valid = false;
      }

      return valid;
    },
    async validateAll() {
      const isDateValid = await this.validateDate();

      const positionsValid = (await this.$refs.positions?.validate?.())?.valid ?? true;
      const requirementsValid = (await this.$refs.requirements?.validate?.())?.valid ?? true;

      if (!isDateValid
        || !this.procedure.goodName
        || !this.procedure.type
        || !this.procedure.subject
        || (!this.procedure.isWithoutStartMaxPrice && !this.procedure.startMaxPrice)
        || !positionsValid
        || !requirementsValid
      ) {
        toast.error('Заполните все обязательные поля');
        return false;
      }
      return true
    },
    showProcedures() {
      this.$router.push({ name: 'procedures.all' });
    },
    showError(error) {
      toast.error(error);
    },
    /**
     * Валидация обязательности поля.
     *
     * @param {*}      newValue   Новое значение поля.
     * @param {string} fieldName  Наименование поля.
     *
     * @return {boolean} Возвращает true, если поле не заполнено. Иначе false.
     */
    validateRequired(newValue, fieldName) {
      let hasErrors = false;
      if (newValue === '' || newValue === null) {
        this.errors[fieldName] = 'Это поле обязательно для заполнения';
        hasErrors = true;
      }
      return hasErrors;
    },
    /**
     * Очистка ошибок полей с датами.
     *
     * @return {void}
     */
    clearDateErrors() {
      this.errors.applicationDeadline = null;
      this.errors.summingStart = null;
    },
  },
  computed: {
    ...mapStores(
      useProcedureStepStore,
      useLibraryStore,
      useProcedureCreateStore,
      useSubjectInfoStore,
    ),
    customStageComponent() {
      const stageStore = useProcedureStageComponentStore();
      return stageStore.getComponentByType(this.procedure.type);
    },
    positionsInfoComponent() {
      const store = usePositionsInfoComponentStore();
      return store.getComponentByType(this.procedure.type);
    },
    statusColor() {
      return this.procedureStepStore.getStatusStyle(this.procedure.status.code);
    },
    getTypes() {
      return this.types.map((elem) => {return {title: elem.name, value: elem.code}});
    },
    nextAvailableTabIndex() {
      for (let i = 0; i < this.tabs.length; i++) {
        const tab = this.tabs[i];
        if (tab.required && !tab.isFilled) {
          return i;
        }
      }
      return this.tabs.length;
    },
    checkClosedReq() {
      return !this.procedure.isClosed || this.procedure.allowedContragents.length > 0
    }
  },
  watch: {
    $route(toRoute) {
      this.id = toRoute.params['id'];
      this.currentTab = 0;
      this.lastTab = 0;
      this.loadForm(this.id);
    },
    procedure: {
      handler: 'updateFilledTabs',
      deep: true
    },
    documents: {
      handler: 'updateFilledTabs',
      deep: true
    },
    'procedure.type': {
      handler(newType) {
        this.$refs.subject?.resetValidation();
        this.$refs.general?.resetValidation();

        this.libraryStore.callActionByCode('initProcedureCreateOptions', {
          procedureType: newType
        });
      }
    }
  },
  mounted() {
    this.fetchRequirementTypes();
    this.loadForm(this.id);
    this.updateFilledTabs();
  },
};
</script>
<style>
.procedureOperations {
  margin-top: 10px;
  padding-top: 0;
  display: flex;
  justify-content: flex-end;

  button {
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    padding: 10px 20px;
    height: auto !important;
    border-radius: 6px;
  }
}

.v-slide-group__content {
  justify-content: space-around;
  align-items: center;
  flex: none;
  gap: 25px;
}

.v-tab {
  font-weight: 600;
  padding: 0;
}

.v-tab--selected {
  opacity: 1;
}

.v-tab--selected .v-tab__slider {
  opacity: 1;
  bottom: 5px;
}

.round:not(:first-child) {
  content: '';
  width: 6px;
  height: 6px;
  background-color: #162040;
  border-radius: 100%;
}

.v-window {
  padding: 2px;
}

.filled {
  opacity: 1;
}

.date-time-picker {
  width: auto !important;
}
</style>
